import {
  Anchor,
  Clapperboard,
  ClipboardList,
  Home,
  Link2,
  type LucideIcon,
  Mail,
  MessageSquare,
  Palette,
  Route,
  Sparkles,
  Truck,
} from 'lucide-react';
import type { ProductKey } from './app-registry';

export interface ProductFeatureLossItem {
  icon: LucideIcon;
  label: string;
}

/**
 * What a cancellation preview shows the org they'd lose access to. Placeholder copy — grounded in
 * each product's actual capabilities (see AGENTS.md) but not yet reviewed by product; correct
 * before shipping to real customers.
 */
export const PRODUCT_FEATURE_LOSS: Record<ProductKey, ProductFeatureLossItem[]> = {
  anchor_contact: [
    { icon: Anchor, label: 'Saved Anchors on every page you track' },
    { icon: Link2, label: 'Links attached to those Anchors' },
    { icon: MessageSquare, label: 'Comment threads on Anchors, Pins, and Tasks' },
    { icon: ClipboardList, label: 'Tasks and project boards' },
  ],
  inbox_clinic: [
    { icon: Mail, label: 'Connected Gmail accounts' },
    { icon: Sparkles, label: 'AI thread summaries and triage' },
    { icon: ClipboardList, label: 'Prescriptions (threads turned into tasks)' },
  ],
  job_plan: [
    { icon: Route, label: 'Route and stop planning' },
    { icon: Truck, label: 'Operator assignments' },
    { icon: Sparkles, label: 'AI route-solver proposals' },
  ],
  real_estate_studio: [
    { icon: Home, label: 'Property listings and their media libraries' },
    { icon: Clapperboard, label: 'Saved studio projects and listing videos' },
    { icon: Palette, label: 'Agency brand kit and saved templates' },
    { icon: Sparkles, label: 'AI co-director and photo touch-ups' },
  ],
};
